import { render, staticRenderFns } from "./BolItau.vue?vue&type=template&id=b4f6df5a&scoped=true&"
import script from "./BolItau.vue?vue&type=script&lang=js&"
export * from "./BolItau.vue?vue&type=script&lang=js&"
import style0 from "./BolItau.vue?vue&type=style&index=0&id=b4f6df5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f6df5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
